import { Amount } from '@lx/shared/data-access/types';

/**
 * Represents the prices of a product. This will have a list with the end prices, the prices and the discount as
 * a string representing the discount (percentage or whatever coming from API).
 */
export interface ProductPrices {
  endPrice: Amount[];
  price: Amount[];
  discount?: string;
}
